<template lang="pug">
    .custom-cascader(:class="{'search-cascader':searchCascade}")
        el-cascader(
            v-model="category",
            :options="goodsCategoryOptions",
            :props="props",
            :disabled="disabled",
            placeholder="请选择商品类目",
            :show-all-levels="false",
            collapse-tags,
            clearable,
            v-bind="options.attrs",
            v-on="options.listeners",
            @change="onChange",
        )
</template>


<script>
import { inventoryApis } from '@/api';

export default {
    name: 'CategoryCascader',
    data() {
        return {
            props: {
                value: 'id',
                label: 'name',
                emitPath: false,
                multiple: this.multiple,
            },
            goodsCategoryOptions: [],
            category: [],
        };
    },

    watch: {
        asyncCategorys: {
            deep: true,
            // eslint-disable-next-line no-unused-vars
            handler(nValue, oValue) {
                this.category = nValue;
            },
        },
        category: {
            deep: true,
            // eslint-disable-next-line no-unused-vars
            handler(nValue, oValue) {
                this.$emit('input', nValue);
            },
        },
    },

    created() {
        this.getOptions();
    },

    props: {
        options: {
            type: Object,
            default: () => ({}),
        },
        searchCascade: {
            type: Boolean,
            default() {
                return true;
            },
        },
        asyncCategorys: {
            type: String,
            default() {
                return undefined;
            },
        },
        multiple: {
            type: Boolean,
            default() {
                return true;
            },
        },
        disabled: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },

    methods: {
        onChange() {
            // this.category = [];
            this.$emit('onChange', this.category);
        },
        async getOptions() {
            const { data } = await inventoryApis.getGoodsCategory();
            this.goodsCategoryOptions = data;
        },
    },
};
</script>

<style lang="scss">
.custom-cascader {
    .el-cascader {
        line-height: 32px !important;
    }
    .el-input {
        height: 32px !important;
        .el-input__inner {
            height: 32px !important;
        }
    }
    .el-scrollbar__view.el-cascader-menu__list.is-empty{
        min-height: 40px !important;
    }
}
.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path {
    color: #4877F4 !important;
}
.search-cascader{
    .el-cascader {
        line-height: 32px !important;
        .el-cascader__tags {
            padding-left: 76px !important;
            right: 30 !important;
        }
    }
}
</style>
